import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RichTextEditor from './Forms/RichTextEditor';
import { ActionButton } from './Forms/ActionButton';
import { useCreateAboutUs, useGetAboutUs, useUpdateAboutUs } from '../queries/appInfo';
import { FaAngleDown, FaAngleRight } from 'react-icons/fa';

const AboutUs = () => {

    // Note: You'll need to provide the id for your About Us content
    // This could come from props, context, or a constant value
    const aboutUsId = "your-about-us-id"; // Replace with actual ID
    
    const { data: aboutUs, isPending: isAboutUsPending } = useGetAboutUs(aboutUsId);
    const { mutateAsync: updateAboutUs, isPending: isUpdating } = useUpdateAboutUs();
    const { mutateAsync: createAboutUs } = useCreateAboutUs();

    const [show, setShow] = React.useState(false);

    const {
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm({
        defaultValues: {
            aboutUsContent: '',
        }
    });

    // Watch form values for rich text editors
    const aboutUsContent = watch('aboutUsContent');

    // Set form values when data is loaded
    useEffect(() => {
        if (aboutUs) {
            setValue('aboutUsContent', aboutUs.content || '');
        }
    }, [aboutUs, setValue]);

    const handleUpdateAppInfo = async (formData) => {
        try {
            if (aboutUs?._id) {
                await updateAboutUs(
                    {
                        id: aboutUs?._id,
                        content: aboutUsContent,
                    },
                    {
                        onSuccess: (res) => {
                            if (res.error) {
                                toast.error();
                                return;
                            }
                            toast.success('About Us Updated!');
                        },
                        onError: (err) => {
                            toast.error('Error updating About Us!');
                        }
                    }
                );
            } else {
                await createAboutUs(
                    { content: aboutUsContent },
                    {
                        onSuccess: (res) => {
                            if (res.error) {
                                toast.error();
                                return;
                            }
                            toast.success('About Us Created!');
                        },
                        onError: (err) => {
                            toast.error('Error creating About Us!');
                        }
                    }
                );
            }
        } catch (err) {
            toast.error("Failed to update about us information");
        }
    };

    if (isAboutUsPending) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="loader">Loading...</div>
            </div>
        );
    }

    return (
        <>
            <div className='bg-white shadow-md rounded-lg p-7'>
                <form onSubmit={handleSubmit(handleUpdateAppInfo)} className="space-y-6">

                    {/* About Us Section */}
                    <div className="bg-gray-50 rounded-lg">
                        <h3 className="text-xl text-primary font-bold mb-4 cursor-pointer flex items-center" onClick={() => setShow(!show)}>{show ? <FaAngleDown className='text-secondary' /> : <FaAngleRight className='text-secondary' />} About Us</h3>
                        {
                            show && (
                                <>
                                    <RichTextEditor
                                        label="About Us Content"
                                        value={aboutUsContent}
                                        placeholder="Enter the about us content for your app..."
                                        onChange={(value) => setValue('aboutUsContent', value)}
                                        required={true}
                                    />
                                    {errors.aboutUsContent && (
                                        <p className="text-red text-sm mt-2">
                                            {errors.aboutUsContent.message || "About Us content is required"}
                                        </p>
                                    )}
                                    {/* Submit Button */}
                                    <div className='flex justify-end mt-6'>
                                        <ActionButton
                                            text={isUpdating ? 'Updating...' : 'Update About Us'}
                                            variant={'submit'}
                                            disabled={isUpdating}
                                        />
                                    </div>
                                </>
                            )
                        }
                    </div>
                </form>
            </div>

            <ToastContainer
                position="top-right"
                autoHideDuration={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

export default AboutUs;